import { apiClient } from './client';

// ── Tipos ─────────────────────────────────────────────────────────────────────

export type ShipmentStatus = 'PENDING' | 'EN_RUTA' | 'ENTREGADO' | 'CANCELADO';

export interface ShipmentBox {
  calibre:  string;
  boxCount: number;
  weightKg: number;
  grade:    'A' | 'B' | 'C';
}

export interface Shipment {
  loteId:            string;
  shipmentId:        string;
  tenantId:          string;
  batchId?:          string;
  driver:            string;
  truckPlate:        string;
  transportCompany?: string;
  destination:       string;
  boxes:             ShipmentBox[];
  kgTotal:           number;
  gradeA:            number;
  gradeB:            number;
  gradeC:            number;
  boxCount:          number;
  status:            ShipmentStatus;
  scheduledAt?:      string;
  departedAt?:       string;
  arrivedAt?:        string;
  freightCost?:      number;
  freightCostPerKg?: number;
  folioId?:          string;
  containerCode?:    string;
  notes?:            string;
  recordedBy:        string;
}

export interface CreateShipmentInput {
  loteId:            string;
  batchId?:          string;
  driver:            string;
  truckPlate:        string;
  transportCompany?: string;
  destination:       string;
  boxes:             ShipmentBox[];
  folioId?:          string;
  containerCode?:    string;
  scheduledAt?:      string;
  notes?:            string;
}

// ── Queries ───────────────────────────────────────────────────────────────────

export const fetchShipments = async (
  opts?: { loteId?: string; period?: string; limit?: number; ranchoId?: string | null },
): Promise<{ shipments: Shipment[]; count: number }> =>
  (await apiClient.get('/api/transport/shipments', {
    params: {
      ...(opts?.loteId && { loteId: opts.loteId }),
      ...(opts?.period && { period: opts.period }),
      ...(opts?.limit != null && { limit: opts.limit }),
      ...(opts?.ranchoId && { ranchoId: opts.ranchoId }),
    },
  })).data;

// ── Mutaciones ────────────────────────────────────────────────────────────────

export const createShipment = async (
  input: CreateShipmentInput,
): Promise<Shipment> =>
  (await apiClient.post('/api/transport/shipments', input)).data;

export const updateShipmentStatus = async (
  shipmentId: string,
  loteId: string,
  status: ShipmentStatus,
  arrivedAt?: string,
  notes?: string,
): Promise<{ shipmentId: string; status: ShipmentStatus }> =>
  (await apiClient.put(`/api/transport/shipments/${shipmentId}/status`, {
    loteId, status, arrivedAt, notes,
  })).data;
